<script>
// quick fix to use mixin with <script setup> syntax
// todo: convert mixins to composable for vue3

import {defineComponent} from "vue";
import mapFilter from "./mixins/MapFilter";


export default defineComponent({
  mixins: [mapFilter],
});


</script>


<script setup>
import moment from "moment";
import 'vue-select/dist/vue-select.css';
import {computed, onMounted, reactive, ref, watch} from "vue";

import {useRoute} from "vue-router";
import FTDatePicker from "../../shared/compat/FTDatePicker.vue";
import FTDropdownSelect from "../../shared/compat/FTDropdownSelect.vue";

const props = defineProps(['attachments', 'users', 'workTasks'])

const downloadCsv = ref([])
const showDownloads = ref(false)
const trees = ref(null)
const offset = ref(3)
const pagination = ref({})
const loading = ref(true)
const selSpecies = ref(null)
const showMore = ref(false)
const showMap = ref(false)
const processType = ref(null)
const groupByDate = ref(false)
const groupByUser = ref(false)
const updatedBetween = ref({start: null, end: null})

const queryDate = ref(null)
const queryType = ref(null)

const selectedWorks = ref([])
const selectedTags = ref([])
const selectedEquipment = ref([])
const isStormEvent = ref(null)

const formattedFilter = computed(() => {
  return {
    works: selectedWorks.value.length ? selectedWorks.value : null,
    tags: selectedTags.value.length ? selectedTags.value : null,
    equipment: selectedEquipment.value.length ? selectedEquipment.value : null,
    storm: isStormEvent.value,
    updatedBetween: updatedBetween.value
  }
})
const emitFilter = () => {
  emits('emit-filter', formattedFilter.value)
}

watch([updatedBetween, selectedWorks, selectedEquipment, selectedTags, isStormEvent], emitFilter, {deep:true});


const STORM_EVENT_OPTIONS = [
  {type: 'Yes', id: true},
  {type: 'No', id: false},
]

const emits = defineEmits(['emit-filter'])

const route = useRoute()


onMounted(() => {
  queryDate.value = route.query.date
  queryType.value = route.query.type

  if (queryDate.value && queryType.value) {
    groupByDate.value = false;
    groupByUser.value = false;
    if (queryType === 'stumps') {
      filter.works_id = [13];
    }
  }
})

const handleResetDate = () => {
  updatedBetween.value = {start: null, end: null};
}

const handleUpdateUpdatedBetween = (value) => {
  if (!value) {
      updatedBetween.value = {start: null, end: null};
      return
  }
  const parseDate = (string) => moment(string).format('YYYY-MM-DD')
  updatedBetween.value['start'] = parseDate(value[0])
  updatedBetween.value['end'] = parseDate(value[1])
}

const textInputFormat = {
    format: "dd/MM/yyyy - dd/MM/yyyy ",
};
</script>


<template>
  <div>
    <div class="w-full">
      <!--     Filter bar container       -->
      <div class="w-full flex flex-wrap justify-center lg:flex-no-wrap lg px-8 pb-4">
        <!--    first date filter    -->
        <div class="w-full lg:w-1/5 p-4">
          <p class="text-md text-slate-600">Dates Between</p>
            <VueDatePicker
                :text-input="textInputFormat"
                mode="range"
                v-model="updatedBetween"
                :format="'dd/MM/yyyy'"
                :range="true"
                :enable-time-picker="false"
                :multi-calendars="2"
                :auto-apply="true"
                @update:modelValue="handleUpdateUpdatedBetween"
            />


          <div class="text-slate-600 hover:text-blue-600 cursor-pointer text-sm mt-1" @click="handleResetDate">Reset
            date
          </div>

        </div>
        <!--        2nd filter tasks        -->
        <div class="w-full lg:w-1/5 p-4">
          <p class="text-md text-slate-600">Work Completed</p>
          <FTDropdownSelect
            class="style-chooser"
            :multiple="true"
            v-model="selectedWorks"
            :options="workTasks"
            label="task"
            :reduce="type => type.id"
          />
        </div>
        <!--    3rd filter tags     -->
        <div v-if="attachments.tags || true" class="w-full lg:w-1/5 p-4">
          <p class="text-md text-slate-600">Tags</p>
          <FTDropdownSelect class="style-chooser" multiple v-model="selectedTags"
                            :options="attachments.tags" label="name"
                            :reduce="settings => settings.id"/>
        </div>

        <!--  3rd filter equipments -->
        <div v-if="attachments.equipment || true" class="w-full lg:w-1/5 p-4">
          <p class="text-md text-slate-600">Equipment</p>
          <FTDropdownSelect class="style-chooser" multiple v-model="selectedEquipment"
                            :options="attachments.equipment" label="name"
                            :reduce="settings => settings.id"/>
        </div>

        <!--    5rd filter Storm event     -->
        <div class="w-full lg:w-1/5 p-4">
          <p class="text-md text-slate-600">Storm Event</p>
          <FTDropdownSelect class="style-chooser"
                    v-model="isStormEvent"
                    :options="STORM_EVENT_OPTIONS"
                    label="type"
                    :reduce="type => type.id"/>
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped>
.ol-popup {
  position: absolute;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  min-width: 200px;
}

.ol-popup:after, .ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}

.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}

.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}

.ol-popup-closer:after {
  content: "\274c";
}

.date-selected-input {
  background: #ffffff;
  border: 1px solid #cbd5e0;
  color: #394066;
  border-radius: 4px;
}

:deep(.dp__input) {
    border: 1px solid #cbd5e0 !important;
    color: #394066 !important;
    border-radius: 4px;
    padding-top: 10px;
    padding-bottom: 10px;

}
</style>
